exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title[data-v-6d4eed19]{font-size:.24rem;width:100%;margin-top:.56rem;color:#97989b;margin-bottom:.76rem;line-height:.36rem;white-space:nowrap;overflow:hidden;text-align:center;padding-bottom:.1rem}.title span[data-v-6d4eed19]{display:inline-block}.number[data-v-6d4eed19]{background:#97989b;width:.36rem;height:.36rem;border-radius:50%;display:inline-block;line-height:.36rem;color:#fff;font-size:.24rem;text-align:center;margin-right:.1rem}.number_new[data-v-6d4eed19]{color:#ff5548}.number_new span[data-v-6d4eed19]:first-child{background:#ff5548}.line[data-v-6d4eed19]{width:.6rem;line-height:.18rem;height:.18rem;border-bottom:1px solid #979797;text-align:center;margin:0 0 .09rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6d4eed19","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/pass-status/components/StatusBar.vue
// module id = MgYW
// module chunks = 1